import { mergeSearchColumns } from '@utils/columns';
import _ from 'lodash';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { grey } from '@material-ui/core/colors';
import { useEsFiles } from '@modules/es-file/es-files';
import { Search } from '@composite/search/search';
import { EsFile } from '@models';
import { EsFileState, ExportTags } from '@enums';
import { useColumns as useAllColumns } from './../es-file-all/all-es-files-columns';
import { useColumns } from './es-file-search-columns';

export function EsFileSearch() {
  const intl = useIntl();
  const columns = useColumns();
  const allColumns = useAllColumns(false).map((col) => {
    col.filterable = false;
    return col;
  });

  const { props } = useEsFiles({
    evidenceProps: {
      version: 4,
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => btn !== 'NEW',
        },
      },
      tableProps: {
        tableName: intl.formatMessage({
          id: 'ES__ES_FILE_SEARCH__TABLE__TITLE',
          defaultMessage: 'Spisy - hledání',
        }),
      },
    },
  });

  return (
    <Search
      apiProps={props.apiProps}
      detailProps={props.detailProps}
      version={props.version}
      tableProps={{
        reportTag: ExportTags.ES_FILES,
        columns: _.uniqBy(mergeSearchColumns(allColumns, columns), 'datakey'),
        settingsKey: 'ES_FILE_SEARCH',
        showSearchbar: true,
        createRowStyle: (item: EsFile) =>
          item.state === EsFileState.REGISTRY
            ? {
                color: grey[500],
                backgroundColor: grey[100],
              }
            : {},
      }}
      filterProps={{
        layout: { type: 'grid', columns: 'auto', minColumnWidth: 280 },
        title: (
          <FormattedMessage
            id="ES__ES_FILE_SEARCH__TOOLBAR__TITLE"
            defaultMessage="Vyhledávání"
          />
        ),
        initVisibility: columns.map((c) => c.datakey),
        defaults: [],
        groupLabels: {
          1: intl.formatMessage({
            id: 'ES__ES_FILE_SEARCH__LABEL_GROUP_1',
            defaultMessage: 'Spis',
          }),
          2: intl.formatMessage({
            id: 'ES__ES_FILE_SEARCH__LABEL_GROUP_2',
            defaultMessage: 'Účastník',
          }),
          3: intl.formatMessage({
            id: 'ES__ES_FILE_SEARCH__LABEL_GROUP_3',
            defaultMessage: 'Napadený akt',
          }),
          4: intl.formatMessage({
            id: 'ES__ES_FILE_SEARCH__LABEL_GROUP_4',
            defaultMessage: 'Zpracovatelé',
          }),
          5: intl.formatMessage({
            id: 'ES__ES_FILE_SEARCH__LABEL_GROUP_5',
            defaultMessage: 'Ostatní',
          }),
        },
      }}
    />
  );
}
